import {
	createValidator,
	composeValidators,
	combineValidators,
	isRequired
	// isAlphabetic,
	// hasLengthLessThan,
	// isNumeric
} from 'revalidate';
import i18n from '../i18n';

/*
 * Deep validation form
 */
const applicationValidator = values => {

	/*
	 * Custom validator
	 */
	const isValidEmail = createValidator(
		message => value => {
			if (value && value.email && !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(value.email)) {
				return message;
			}
		},
		i18n.t('validation.error.required')
	)

	/*
	 * Custom validator
	 */
	const greaterThanZero = createValidator(
		message => value => {
			if (!/^\d+$/.test(value) || parseInt(value) <= 0) {
				return message;
			}
		},
		i18n.t('validation.error.invalidNumber')
	)

	/*
	 * Custom validator
	 */
	const birthYearValidator = createValidator(
		message => value => {
			if (!/^\d+$/.test(value) || parseInt(value) <= 1900 || parseInt(value) > new Date().getFullYear()) {
				return message;
			}
		},
		i18n.t('validation.error.invalidBirthYear')
	)

	/*
	 * Custom validator
	 */
	const isValidEmailFlatten = createValidator(
		message => value => {
			if (value && !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(value)) {
				return message;
			}
		},
		i18n.t('validation.error.email')
	)

	/*
	 * Phone number validator
	 */
	const phoneNumberValidator = createValidator(
		message => value => {
			if (!value.privatePhoneNumber && !value.businessPhoneNumber && !value.mobilePhoneNumber) {
				return message;
			}
		},
		i18n.t('validation.error.phoneNumber')
	)

	/*
	 * Override default isRequired
	 */
	const customIsRequired = isRequired({message: i18n.t('validation.error.required')})

	/*
	 * Define validators. order has to follow the order of the field
	 */
    const validator = {};

    if (values.mainApplicant) {
		const mainApplicantValidator = combineValidators({
			salutation: customIsRequired,
			firstName: customIsRequired,
			lastName: customIsRequired,
			address: customIsRequired,
			postalCode: customIsRequired,
			locality: customIsRequired,
			birthYear: composeValidators(
				customIsRequired,
				birthYearValidator
			)(),
            civilStatus: customIsRequired,
            occupation: customIsRequired,
			privatePhoneNumber: phoneNumberValidator,
			businessPhoneNumber: phoneNumberValidator,
			mobilePhoneNumber: phoneNumberValidator,
			email: composeValidators(
				isValidEmailFlatten,
				customIsRequired
			)(),
			debtEnforcementMeasures: customIsRequired
		})
		validator.mainApplicant = mainApplicantValidator(values.mainApplicant)
	}

	if (Array.isArray(values.childrenBirthYears)) {
		validator.childrenBirthYears = values.childrenBirthYears.map(customIsRequired)
	}

	if (values.additionalApplicants) {
		const applicantValidator = combineValidators({
			salutation: customIsRequired,
			firstName: customIsRequired,
			lastName: customIsRequired,
			address: customIsRequired,
			postalCode: customIsRequired,
			locality: customIsRequired,
            privatePhoneNumber: phoneNumberValidator,
            businessPhoneNumber: phoneNumberValidator,
            mobilePhoneNumber: phoneNumberValidator,
            email: isValidEmail,
            birthYear: composeValidators(
                customIsRequired,
                birthYearValidator
            )(),
            civilStatus: customIsRequired,
			occupation: customIsRequired,
			debtEnforcementMeasures: customIsRequired
		})
		validator.additionalApplicants = values.additionalApplicants.map(applicantValidator)
	}

    /*
     * validate checkboxes
     */
	// field numberOfPeople does not exist in form:
	// validator.numberOfPeople = composeValidators(customIsRequired,greaterThanZero)()(values.numberOfPeople);
	validator.liabilityInsurance = customIsRequired(values.liabilityInsurance);
    validator.rentExceedsOneFourthOfIncome = customIsRequired(values.rentExceedsOneFourthOfIncome);
    validator.currentLandlord = customIsRequired(values.currentLandlord);
    validator.currentLeaseWasCancelled = customIsRequired(values.currentLeaseWasCancelled);
    validator.termsAccepted = customIsRequired(values.termsAccepted);
    validator.privacyStatementRead = customIsRequired(values.privacyStatementRead);
    validator.termsRead = customIsRequired(values.termsRead);

    return validator
};


export default applicationValidator
